module.exports = __webpack_public_path__ + "img/pd_m_3_fr.b60192ca.jpg";